
// Services.js

import React from "react";
import styled, { keyframes } from "styled-components";
import {
  FiLayers,
  FiGrid,
  FiHome,
  FiDroplet,
  FiCheckCircle
} from "react-icons/fi";


const fadeUp = keyframes`
from{
  opacity:0;
  transform:translateY(35px);
}
to{
  opacity:1;
  transform:translateY(0);
}
`;



const ServicesSection = styled.section`

padding:6rem 1.5rem;


background:

linear-gradient(
180deg,
${({theme})=>theme.colors.bgAccent},
${({theme})=>theme.colors.white}
);


overflow:hidden;

`;



const Container = styled.div`

max-width:1280px;

margin:0 auto;

`;



const HeaderContainer = styled.div`

max-width:750px;

margin:0 auto 4rem;

text-align:center;


`;



const SectionBadge = styled.div`

display:inline-flex;

align-items:center;

justify-content:center;


padding:.45rem 1.2rem;


border-radius:50px;


background:${({theme})=>theme.colors.primaryLight};


color:${({theme})=>theme.colors.primary};


font-size:.8rem;


font-weight:800;


letter-spacing:.1em;


text-transform:uppercase;


margin-bottom:1rem;


`;



const SectionTitle = styled.h2`

font-size:clamp(2rem,4vw,3rem);


font-weight:800;


line-height:1.15;


letter-spacing:-1px;


color:${({theme})=>theme.colors.textDark};


margin-bottom:1rem;


`;



const SectionSubtitle = styled.p`

font-size:1.05rem;


line-height:1.7;


color:${({theme})=>theme.colors.textMuted};


`;



const Grid = styled.div`

display:grid;


grid-template-columns:repeat(2,1fr);


gap:2rem;


@media(max-width:${({theme})=>theme.breakpoints.tablet}){

grid-template-columns:1fr;

}


`;



const ServiceCard = styled.article`

position:relative;


background:${({theme})=>theme.colors.white};


border:1px solid ${({theme})=>theme.colors.border};


border-radius:24px;


padding:2.3rem;


overflow:hidden;


box-shadow:

0 10px 30px rgba(15,23,42,.06);


transition:${({theme})=>theme.transitions.default};


animation:${fadeUp}.7s ease both;



&::before{

content:"";


position:absolute;


top:0;

left:0;


height:5px;


width:100%;


background:

linear-gradient(
90deg,
${({theme})=>theme.colors.primary},
${({theme})=>theme.colors.secondary}
);


transform:scaleX(0);


transform-origin:left;


transition:.4s;


}



&:hover{

transform:translateY(-10px);


box-shadow:

0 25px 50px rgba(15,23,42,.12);


}



&:hover::before{

transform:scaleX(1);


}



@media(max-width:${({theme})=>theme.breakpoints.mobile}){

padding:1.7rem;

}


`;



const CardTop = styled.div`

display:flex;

justify-content:space-between;

align-items:center;


margin-bottom:1.5rem;


`;



const IconBadge = styled.div`

width:68px;

height:68px;


display:flex;

align-items:center;

justify-content:center;


border-radius:20px;


background:

linear-gradient(
135deg,
${({theme})=>theme.colors.primaryLight},
${({theme})=>theme.colors.secondaryLight}
);


color:${({theme})=>theme.colors.primary};


font-size:2rem;


transition:.3s;


${ServiceCard}:hover &{

transform:rotate(-5deg) scale(1.05);

}


`;



const CategoryNumber = styled.span`

font-size:3rem;


font-weight:900;


color:${({theme})=>theme.colors.bgAccent};


line-height:1;


`;



const CardTitle = styled.h3`

font-size:1.35rem;


font-weight:800;


line-height:1.3;


color:${({theme})=>theme.colors.textDark};


margin-bottom:.8rem;


`;



const CardDescription = styled.p`

font-size:.98rem;


line-height:1.7;


color:${({theme})=>theme.colors.textMuted};


margin-bottom:1.8rem;


`;



const FeatureList = styled.ul`

list-style:none;


display:flex;


flex-direction:column;


gap:.8rem;


padding-top:1.2rem;


border-top:1px solid ${({theme})=>theme.colors.border};


`;



const FeatureItem = styled.li`

display:flex;


align-items:center;


gap:.7rem;


font-size:.9rem;


font-weight:600;


color:${({theme})=>theme.colors.textDark};


svg{

color:${({theme})=>theme.colors.primary};

flex-shrink:0;

}


`;





export default function Services(){


const servicesList=[


{

number:"01",

icon:<FiLayers/>,

title:"Architectural Plastering & Rendering",

description:
"Professional internal and external plastering solutions delivering smooth finishes, durability, and architectural excellence.",

features:[

"Internal Smooth Wall Plastering",

"Exterior Cement Rendering",

"Decorative & Textured Wall Finishes"

]

},



{

number:"02",

icon:<FiGrid/>,

title:"Precision Floor & Wall Tiling",

description:
"Expert installation of premium tiles including porcelain, ceramic, marble, granite, and customized patterns.",

features:[

"Large Format Porcelain Installation",

"Marble & Granite Flooring",

"Custom Mosaic Pattern Laying"

]

},



{

number:"03",

icon:<FiHome/>,

title:"Cladding & Surface Coverings",

description:
"Architectural surface solutions including facade cladding, stone panels, and protective wall coverings.",

features:[

"Building Facade Cladding",

"Architectural Stone Installation",

"Decorative Surface Panels"

]

},



{

number:"04",

icon:<FiDroplet/>,

title:"Subfloor Preparation & Leveling",

description:
"Advanced preparation services ensuring accurate leveling, waterproofing, and long-lasting tile performance.",

features:[

"Self-Leveling Screed",

"Waterproofing Membrane Installation",

"Surface Inspection & Preparation"

]

}


];



return(


<ServicesSection id="services">


<Container>



<HeaderContainer>


<SectionBadge>

Professional Services

</SectionBadge>



<SectionTitle>

Specialized Contracting Services

</SectionTitle>



<SectionSubtitle>

Delivering precision workmanship and premium architectural finishing solutions for residential and commercial developments across UAE.

</SectionSubtitle>


</HeaderContainer>




<Grid>


{

servicesList.map((service,index)=>(


<ServiceCard

key={index}

style={{

animationDelay:`${index*0.12}s`

}}

>


<CardTop>


<IconBadge>

{service.icon}

</IconBadge>


<CategoryNumber>

{service.number}

</CategoryNumber>


</CardTop>




<CardTitle>

{service.title}

</CardTitle>



<CardDescription>

{service.description}

</CardDescription>




<FeatureList>


{

service.features.map((feature,i)=>(


<FeatureItem key={i}>


<FiCheckCircle/>


{feature}


</FeatureItem>


))


}



</FeatureList>



</ServiceCard>


))


}



</Grid>



</Container>


</ServicesSection>


);


}
